
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from './data.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { StorageService } from './storage.service';
import config from '../../assets/config.json';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import {MemoryStorageService} from './memory-storage.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
//const _validFileExtensions = ['.pdf', '.tiff', '.tif','.docx','.xlsx','.xls','.jpg','.jpeg'];
//const _fileSize =10;
import cookies from 'js-cookie';
import { Key } from 'readline';
var CryptoJS = require("crypto-js");

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private loading: boolean = false;
  public isSessionExpired = false;
  public isLoggedOut = false;
  public configvalue = config.inputvalue;
  setLoading(loading: boolean) {
    this.loading = loading;
  }
  getLoading(): boolean {
    return this.loading;
  }
  public get getRegForDecimal() { return /^-?\d*(\.\d{0,5})?$/; }
  public get getRegExpForAmount() { return /^(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?$/; }

  // public get selectedProject() { return this.getUserInfoFromLocalStorage('projectId'); }
  // public get selectedSubgroup() { return this.getUserInfoFromLocalStorage('subgroupId'); }
  // public get selectedRole() { return this.getUserInfoFromLocalStorage('roleId'); }
  // //public get defaultroleId() { return this.getUserInfoFromLocalStorage('defaultroleId'); }
  // public get selectedIsInitiator() { return this.getUserInfoFromLocalStorage('is_initiator'); }
  // public get selectedIsimplementation() { return this.getUserInfoFromLocalStorage('is_implementation'); }
  public get selectedProject() { return this.memorystore.getItem('projectId'); }
  public get selectedSubgroup() { return this.memorystore.getItem('subgroupId'); }
  public get selectedRole() { return this.memorystore.getItem('roleId'); }
  //public get defaultroleId() { return this.getUserInfoFromLocalStorage('defaultroleId'); }
  public get selectedIsInitiator() { return this.memorystore.getItem('is_initiator'); }
  public get selectedIsimplementation() { return this.memorystore.getItem('is_implementation'); }
  //public get validFileExtensions() { return _validFileExtensions.toString(); }
  //public get fileSize() { return _fileSize; }
  dp = new DatePipe('en-US');
  minDate: Date = new Date('1900-01-01');
  public reportList: any = [];
  public sesValidationRequired = config.ses_validation_required;
  public sesLineitemFetchRequired = config.ses_lineitem_fetch_required;
  public encodeSpecialCharInSesValidation = config.encode_special_char_in_ses_validation;
  fileSizeUnit: number = 1024;
  public isApiSetup = false;
  allcookies:{[key:string]:Key}={};
  constructor(private storageService: StorageService, private dialog: MatDialog, private _snackBar: MatSnackBar, private dataService: DataService, private _http: HttpClient, private router: Router,private memorystore:MemoryStorageService,private encryptDecryptservice: EncryptDecryptService) {
  }

  private _isLoading = new BehaviorSubject<boolean>(false);
  isLoading = this._isLoading.asObservable();
  showHideLoader(isLoading: boolean) { this._isLoading.next(isLoading); }

  public setUserInfoToLocalStorage(key: string, value: any) {
    this.storageService.secureStorage.setItem(key, value);
    //localStorage.setItem(key, value);
  }

  public getUserInfoFromLocalStorage(key: string): any {

    let result = this.storageService.secureStorage.getItem(key);
    if (result != null && result != undefined) {
      return result.toString();
    }
    return result;
    // if (key in localStorage) {
    //   return localStorage.getItem(key);
    // }
    // return null;
  }
  /*Added by Dharshana on 19-09-2025 for storing secure data in js cookies */
  public setcookiedata(key: string, value: any) {
    var keyname = this.hash(key);
    if (value != undefined && value != null) {
      var setvalue = this.encrypt(value.toString());
      // cookies.set(keyname, setvalue,{
      //   httpOnly:true,  
      //   secure:true,
      //   sameSite:'strict'
      // });
      cookies.set(keyname, setvalue);
      // cookies.set(keyname, setvalue,{
      //   secure:true,
      //   sameSite:'None',
      // });
    }
  }
  public getcookiedata(key: string): any {
    var keyname = this.hash(key);
    // var setvalue = this.encrypt(value.toString());
    var getdata = cookies.get(keyname);
    if (getdata != undefined && getdata != null) {
      return this.decrypt(getdata);
    }
  }
  public setuserdatacookiedata(key: string, value: any){
    var keyname = this.hash(key);
    cookies.set(keyname, value);
  }
  public getuserdatacookiedata(key: string){
    var keyname = this.hash(key);
    // var setvalue = this.encrypt(value.toString());
    var getdata = cookies.get(keyname);
    return getdata;
  }
  public hash(key: any): any {
    key = CryptoJS.SHA256(key, this.configvalue.toString()+"90");
    return key.toString();
  }
  public encrypt(data: any) {
    data = CryptoJS.AES.encrypt(data,  this.configvalue.toString()+"90");
    data = data.toString();
    return data;
  }
  public decrypt(data: any) {
    data = CryptoJS.AES.decrypt(data,  this.configvalue.toString()+"90");
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
  }
  /*Added by Dharshana on 19-09-2025 for storing secure data in js cookies */
  public clearSession() {
    return this.storageService.secureStorage.clear();
  }

  public exportAsExcelFile(json: any[], excelFileName: string, isExcludeID: boolean = false): void {
    if (isExcludeID) {
      json.forEach(u => delete u.ID);
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public secondsTo_dd_hh_mm_ss(seconds: number) {
    seconds = Number(seconds);
    let d = Math.floor(seconds / 3600 / 24);
    let h = Math.floor(seconds / 3600 % 24);
    let m = Math.floor(seconds % 3600 / 60);
    let s = Math.floor(seconds % 3600 % 60);
    return (d < 10 ? "0" + d : d) + ' ' + (h < 10 ? "0" + h : h) + ':' + (m < 10 ? "0" + m : m) + ':' + (s < 10 ? "0" + s : s);
  }

  public showMessageBox(text: string, title: string = "Alert", icon = "", cssClass = "") {
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent,
      {
        disableClose: true,
        data: {
          message: text,
          icon: icon,
          title: title,
          cssClass: cssClass,
          messageBoxType: 'ok'
        }
      });
  }

  public closemessagebox() {
    const dialogRef1 = this.dialog.closeAll();
  }

  public editmessagebox(text: string, respose: string, wisdomnetresponse: String, title: string = "PII Agent", icon = "", cssClass = "") {
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent,
      {
        disableClose: true,
        data: {
          message: text,
          icon: icon,
          title: title,
          cssClass: cssClass,
          messageBoxType: 'ok',
          piiresponse: true,
          piiresponsetext: respose,
          wisdomnetresponse: wisdomnetresponse
        }
      });
  }

  public showSnackBar(message: string, type: string = "", interval: number = 5000) {
    var panelClass: string = 'info_snackbar';
    if (type.toLowerCase() == "success") {
      panelClass = "success_snackbar";
    } else if (type.toLowerCase() == "warning") {
      panelClass = "warning_snackbar";
    } else if (type.toLowerCase() == "error") {
      panelClass = "error_snackbar";
    }
    this._snackBar.open(message, "X", {
      duration: interval,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

  public async getDropdownData(fieldId: string | number, fieldValue: number = 0, dependent_parameter: any = {}) {

    let params = {
      field_mapping_detail_id: fieldId,
      field_value: fieldValue ? fieldValue : 0,
      dependent_parameter: dependent_parameter,
      xusrid : this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))//Added by imran on 01-04-26

    };

    const result = await this.dataService.postData('dropdown', params).toPromise();
    if (result != null && (result.error_message == null || result.error_message == "")) {
      if (result.status == true) {
        const uniqueData = [...new Map(result.data.map(item => [item['name'], item])).values()];
        return uniqueData;
      } else {
        return [];
      }
    }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.router.navigateByUrl('/unauthorized');
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.showMessageBox("Internal error")
      }
      return [];
    }
  }

  async getAutocomplete_dropdowndata(fieldMappingDetailId, searchkeyword, search_flag) {

    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      keyword: searchkeyword.toString(),
      search_flag: search_flag
    };

    const result = await this.dataService.postData('dropdown_autocomplete', params).toPromise();
    return result.data;
  }


  async get_field_value_based_validation_settings(params) {

    const result = await this.dataService.postData('get-field_value_based_validation_settings', params).toPromise();
    if (result != null && (result.error_message == null || result.error_message == "")) {
      return result.data;
    }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.showMessageBox("Internal error")
      }
    }
  }

  async get_bulk_field_value_based_validation_settings_async(params) {

    const result = await this.dataService.postData('get-bulk_field_value_based_validation_settings', params).toPromise();
    if (result != null && (result.error_message == null || result.error_message == "")) { }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.showMessageBox("Internal error")
      }
    }
    return result.data;
  }

  public async getDropdownData_Excel(fieldId: string | number, fieldValue: number = 0, dependent_parameter: any = {}) {

    let params = {
      field_mapping_detail_id: fieldId,
      field_value: fieldValue ? fieldValue : 0,
      dependent_parameter: dependent_parameter
    };

    const result = await this.dataService.postData('dropdown_excel', params).toPromise();
    if (result != null && (result.error_message == null || result.error_message == "")) {
      const uniqueData = [...new Map(result.data.map(item => [item['name'], item])).values()];
      return uniqueData;
    }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.router.navigateByUrl('/unauthorized');
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.showMessageBox("Internal error")
      }
      return [];
    }

  }

  public dateFormating(value: string) {
    if (value == '' || value == null || value == undefined) {
      return value;
    }
    var d = new Date(value),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  public getRestrictedKeywords() {
    const restrictedKeywords = [{ restrict: 'create', replace: 'crate' }, { restrict: 'drop', replace: 'drp' },
    { restrict: 'alter', replace: 'alt' }, { restrict: 'truncate', replace: 'trunc' },
    { restrict: 'insert', replace: 'ins' }, { restrict: 'update', replace: 'updt' },
    { restrict: 'delete', replace: 'del' }, { restrict: 'grant', replace: 'grnt' },
    { restrict: 'revoke', replace: 'rvoke' }, { restrict: 'commit', replace: 'comit' },
    { restrict: 'rollback', replace: 'rolback' }, { restrict: 'select', replace: 'slect' },
    { restrict: 'script', replace: 'scrpt' }, { restrict: 'alert', replace: 'alrt' },
    { restrict: '\'', replace: '' }, { restrict: '"', replace: '' }];

    return restrictedKeywords;
  }

  public validateFileUpload(fileData, validFileExtensions, fileSize) {
    let sFileName = fileData.name;
    let sFileSize = fileData.size;
    let validationMessage = '';

    if (sFileName.length > 0) {
      var blnValid = false;
      for (var j = 0; j < validFileExtensions.length; j++) {
        var sCurExtension = validFileExtensions[j];
        if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
          blnValid = true;
          break;
        }
      }

      if (!blnValid) {
        validationMessage =
          'Please upload only  ' +
          validFileExtensions.join(', ') +
          '  file type';
      }
    }

    if (sFileSize > fileSize * 1024 * 1024) {
      if (validationMessage != '') {
        validationMessage = validationMessage + ' and uploaded file size is exceeding the limit.</br> Max limit is ' + fileSize + ' MB.';
      } else {
        validationMessage = 'Uploaded file size is exceeding the limit.</br> Max limit is ' + fileSize + ' MB.';
      }
    }

    if (validationMessage != '') {
      this.showMessageBox(validationMessage, 'Alert');
      return false;
    }

    return true;
  }
  public validateClientLogo(fileData, fileSize) {
    let sFileName = fileData.name;
    let sFileSize = fileData.size;
    //let validationMessage = '';
    let validExtension = ['png'];
    let fileExtension = sFileName.split('.').pop() ?.toLowerCase();
    if (!validExtension.includes(fileExtension || '')) {
      this.showMessageBox('Invalid format type.<br> Please upload .png format only', 'Alert');
      return false;
    }
    if (sFileSize > fileSize * 1024) {
      this.showMessageBox('Uploaded Image size is exceeding the limit.</br> Max limit is ' + fileSize + ' KB.', 'Alert');
      return false;
    }
    // if (validationMessage != '') {
    //   this.showMessageBox(validationMessage, 'Alert');
    //   return false;
    // }

    return true;
  }


  public handleNumberInput(field: any, feild_value: any) {
    if (field != undefined && field != null) {
      let isNumericControl = field.value_type != undefined ?
        ((field.value_type.toLowerCase() == "number" || field.value_type.toLowerCase() == "numeric" || field.validation_type.toLowerCase() == 'amount') ? true : false) : false;
      if (isNumericControl) {
        //let isIntegerField = field.precision_point != undefined ? (field.precision_point > 0 ? false : true) : true;
        feild_value = parseFloat(feild_value).toFixed(Number(field.precision_point));
        return feild_value;
      }
    }
    return feild_value;
  }

  // manipulate api url to outcome proxy/cors origin issue
  // public rewriteRealtimeApiUrl(apiUrl: string) {

  //   if (apiUrl.includes('http://10.251.230.145:8096'))
  //     apiUrl = apiUrl.replace('http://10.251.230.145:8096', 'VatCode');
  //   return apiUrl;
  // }

  public getUserInfoFileFromLocalStorage(key: string): any {
    if (key in localStorage) {
      return atob(localStorage.getItem(key));
      // return localStorage.getItem(key);
    }
    return null;
  }

  public async openAttachment(urn: string, filePath: string) {
    if (config.isuseImageVirtual == false || config.isuseImageVirtual == undefined) {

      filePath = filePath.substring(filePath.lastIndexOf("/") + 1, filePath.length)

      let params = new HttpParams();
      params = params.append('urn', urn);
      params = params.append('filePath', filePath);

      let body = {
        urn: urn,
        filePath: filePath
      };


      await this.dataService
        .postDownloadFilePromise('workitem/getInvoiceBase64', body)
        .then((res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.body != undefined) {
              let downloadLink = document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(res.body);
              downloadLink.setAttribute('download', filePath);
              document.body.appendChild(downloadLink);
              downloadLink.click();
              downloadLink.remove();
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });

      /*this.dataService.getData('workitem/getInvoiceBase64', params).subscribe((response) => {
        if (response.data != null) 
          {
              if (filePath != '') {
                let fileExt = filePath.split('.')[filePath.split('.').length - 1];
                let fileName = filePath.split('/')[filePath.split('/').length - 1];
                const contentType = 'application/' + fileExt;
                const blob = this.b64toBlob(response.data, contentType);
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = fileName
                link.click();
                  } 
                  else
                   {
                let invoiceFileWindow = window.open('');
                invoiceFileWindow.document.write(
                  `<style>body{margin:0;} iframe{border:none;}</style><iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
                    response.data
                  )}'></iframe>`
                );
                  }
        } else {
          this.showMessageBox('File not found.', 'Alert');
        }
      });*/



    } else {
      if (filePath != '') {
        let relativefile = filePath;
        // let imageDirectoryURL = config.imageServerVirtualDirectory;
        let imageDirectoryURL ="";
        let Finalfilepath: any = imageDirectoryURL + relativefile;
        window.open(Finalfilepath);
      }
      else {
        this.showMessageBox('File not found.', 'Alert');
      }
    }
  }

  public openReportAttachment(urn: string, filePath: string) {
    let params = new HttpParams();
    params = params.append('urn', urn);
    params = params.append('filePath', filePath);
    this.dataService.getData('workitem/getInvoiceBase64', params).subscribe((response) => {
      if (response != null && (response.error_message == null || response.error_message == "")) {
        if (response.data != null) {
          if (filePath != '') {
            let fileExt = filePath.split('.')[filePath.split('.').length - 1];
            let fileName = filePath.split('/')[filePath.split('/').length - 1];
            const contentType = 'application/' + fileExt;
            const blob = this.b64toBlob(response.data, contentType);
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName
            link.click();
          } else {
            let invoiceFileWindow = window.open('');
            invoiceFileWindow.document.write(
              `<style>body{margin:0;} iframe{border:none;}</style><iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
                response.data
              )}'></iframe>`
            );
          }
        } else {
          this.showMessageBox('File not found.', 'Alert');
        }
      }
      else {
        if (response.errorCode != 0 && response.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (response.errorCode != 0 && response.errorCode == 3000) {
          this.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }


  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public formatDate(date: any, format: string): string {
    return this.dp.transform(new Date(date), format);
  }

  public get DateFormat() {
    // let format = this.getUserInfoFromLocalStorage('dateFormat');
    let format = this.memorystore.getItem('dateFormat');
    if (format == null || format == undefined || format == '') {
      format = 'DD-MMM-yyyy'
    }
    return format;
  }

  formatCurrencyValue(event: any) {
    let input = event.target.value;
    if (!this.getRegExpForAmount.test(input)) {
      event.target.value = '';
    } else {
      event.target.value = input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  public convertToAmountFormat(val) {
    if (this.getRegExpForAmount.test(val))
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else
      return val;
  }
  public readInput(value: any) {
    if (value != null && value != undefined && value != "")
      return value
    return "";
  }

  public readObject(value: any) {
    if (value != null && value != undefined && value != "")
      return value
    return null;
  }

  public findInvalidControls(formName: any) {
    const invalid = [];
    const controls = formName.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  getFileSize(fileSize: number): number {
    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSize = parseFloat((fileSize / this.fileSizeUnit).toFixed(2));
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSize = parseFloat(
          (fileSize / this.fileSizeUnit / this.fileSizeUnit).toFixed(2)
        );
      }
    }

    return fileSize;
  }

  getFileSizeUnit(fileSize: number) {
    let fileSizeInWords = 'bytes';

    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit) {
        fileSizeInWords = 'bytes';
      } else if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSizeInWords = 'KB';
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSizeInWords = 'MB';
      }
    }

    return fileSizeInWords;
  }


  public numberWithCommas(x) {
    //x = x !=0 ? x/1000 : x;
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  public freezeColumn(col, type = "") {
    let fronzenCols = ["s.no", "sr.no.", "month", "schedule", "schedule id", "entity/territory", "question", "sno", "urn", "territory", "month name", "schedule name", "schedulename", "field name", "monthname", "unit name", "account code"];
    if (type == "question") {
      if (col.toLowerCase() == "tower") return true;
    }
    if (type == "geozone") {
      if (col.toLowerCase() == "completed") return true;
    }
    if (fronzenCols.includes(col.replace("_", " ").toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  public numberRemoveCommas(x) {
    //return (parseInt(x.replaceAll(",", ""))*1000).toString();
    return x.replaceAll(",", "");
  }

  public isNumeric(x) {
    return !isNaN(parseFloat(x)) && isFinite(x);
  }

  public removeCommasIfNumeric(x) {
    let x1 = x.split(',');
    if (Array.isArray(x1) && x1.length > 1) x1 = x1[1];
    if (this.isNumeric(x1)) {
      return this.numberRemoveCommas(x);
    }
    return x;
  }

  public addCommasIfNumeric(x) {
    if (this.isNumeric(x)) {
      return this.numberWithCommas(x);
    }
    return x;
  }
  public detecookie(){
    this.allcookies = cookies.get();
    for(const key in this.allcookies){
      if(this.allcookies.hasOwnProperty(key)){
        cookies.remove(key);
      }
    }
    // var cookielist =["23ac944be61d6c1753b9495d074d758d2501396868daa87c0a4a964dc2666ab5","24b46c265012372c8dcb0cd691f8987b694564bd62960434e85adca52468d950",]
  }
}




